<style lang="scss" scoped>
.access {
	padding: 0;
	img {
		height: 50px;
		padding-right: 10px;
	}
}
</style>

<template lang="pug">
	el-card.access(v-loading="$apollo.loading")
		el-table(v-if="School", :data="School.State")
			el-table-column(width="100px", prop="Company.application_logo")
				template(slot-scope="scope")
					img(:src="scope.row.Company.application_logo", v-if="scope.row.Company.application_logo")
			el-table-column(label="Application", prop="Company.application_name")
				template(slot-scope="scope")
					strong.highlight {{ scope.row.Company ? scope.row.Company.application_name : "N/A"}}
			el-table-column(label="state", prop="state")
			el-table-column(align="right")
				template(slot-scope="scope")
					el-button(size="medium", type="danger") Revoke access
</template>

<script>
import SchoolQuery from "@/graphql/queries/School";

export default {
	apollo: {
		School: {
			query: SchoolQuery,
			variables() {
				return {
					id: this.$route.params.school
				};
			}
		}
	}
};
</script>
